// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3VWeB","overflowing":"ReadFullNote_overflowing__3apD4"};